import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import {
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GridApiPro,
  GridRowSelectionModel,
} from '@mui/x-data-grid-pro';

export type DataGridListType =
  | 'studentList'
  | 'schoolCenterList'
  | 'exportSchoolList'
  | 'exportTourList'
  | 'tourList'
  | 'schoolList'
  | 'schoolList_in_schoolCenter'
  | 'transportationModelsList'
  | 'transportationCompanyList'
  | 'driverList'
  | 'vehicleList'
  | 'schoolVacationTemplateList'
  | 'schoolVacationPeriodList_in_school'
  | 'schoolVacationTemplateList_edit'
  | 'employeeList'
  | 'employeeListForMessages'
  | 'mapSchoolList'
  | 'mapStudentList'
  | 'mapTourList'
  | 'mapVehicleList'
  | 'mapEmployeeList'
  | 'trackComparisonList'
  | 'placeList'
  | 'studentApplicationList'
  | 'fromTourSuggestions'
  | 'tourStudentMatrix'
  | 'roadblockList'
  | 'tourBundleList';

export function saveDataGridStateToLocalStorage(
  dataGridType: DataGridListType,
  data: GridInitialStatePro
) {
  localStorage.setItem(dataGridType, JSON.stringify(data));
}

export function getDataGridStateFromLocalStorage(dataGridType: DataGridListType) {
  const data = localStorage.getItem(dataGridType);
  if (data !== undefined && data !== null) {
    return JSON.parse(data);
  }
  return {} as GridInitialStatePro;
}

export function restoreDataGridStateWithCustomAction(
  apiRef: React.MutableRefObject<GridApiPro>,
  dataGridState: GridInitialStatePro
) {
  apiRef.current.restoreState({
    pagination: dataGridState.pagination,
    sorting: dataGridState.sorting,
    filter: dataGridState.filter,
    columns: dataGridState.columns,
    pinnedColumns: dataGridState.pinnedColumns,
    // preferencePanel causes flickering of filterpanel
    // preferencePanel: dataGridState.preferencePanel
  });
}

export function saveCheckboxSelectionToLocalStorage(
  dataGridType: DataGridListType,
  selection: GridRowSelectionModel
) {
  localStorage.setItem(`${dataGridType}_selection`, JSON.stringify(selection));
}

export function getCheckboxSelectionFromLocalStorage(
  dataGridType: DataGridListType
): GridRowSelectionModel {
  const data = localStorage.getItem(`${dataGridType}_selection`);
  if (data !== undefined && data !== null) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Error parsing checkbox selection:', error);
      return [];
    }
  }
  return [];
}

export function setCheckboxToPinnedColumns(dataGridState: GridInitialStatePro) {
  let state = dataGridState;
  if (isEmptyObject(state)) {
    // No datagrid state exists
    state = {
      pinnedColumns: {
        left: [GRID_CHECKBOX_SELECTION_COL_DEF.field],
        right: [],
      },
    };
    return state;
  }

  if (
    state.pinnedColumns &&
    Array.isArray(state.pinnedColumns.left) &&
    !state.pinnedColumns.left.includes(GRID_CHECKBOX_SELECTION_COL_DEF.field)
  ) {
    // Datagrid state exists, pinnedColumns exists but without pinned checkbox
    state.pinnedColumns.left.unshift(GRID_CHECKBOX_SELECTION_COL_DEF.field);
    return state;
  }

  if (!isEmptyObject(state) && isEmptyObject(state.pinnedColumns)) {
    // Datagrid state exists, but no pinnedColumns exists
    state.pinnedColumns = {
      left: [GRID_CHECKBOX_SELECTION_COL_DEF.field],
      right: [],
    };
    return state;
  }

  return state;
}

export const isEmptyObject = (args: unknown): boolean => JSON.stringify(args) === '{}';
